/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import {
  Modal,
  Radio,
  Input,
  Form,
  List,
} from 'semantic-ui-react';
//import { observer, inject } from 'mobx-react';
//import cx from 'classnames';
import $ from 'jquery';
import api from '../../api';
//import { convertPropertiesToCamelCase } from '../../utils/shared';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import DatesRangeInput from '../DatesRangeInput/DatesRangeInput';
//import WithRouter from '../Extensions/WithRouter';

class ProjectExportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMPE: props.isOpenMPE,
      isLoading: props.isLoading,
      exportType: 'report',
      exportFormat: 'excel',
      selectedVersion: 'all',
      datesRange: '',
      versionList: [],
      radioValue: 'udtime_any',
      startId: 0,
      endId: 0,
      reportAfterExport: {},
      precisionLevel: '',
      toExport: 'local'
    };
    this.onCloseHandler = this.onCloseHandler.bind(this);
    this.onExport = this.onExport.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.handleDateRange = this.handleDateRange.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleIntervalStartChange = this.handleIntervalStartChange.bind(this);
    this.handleIntervalEndChange = this.handleIntervalEndChange.bind(this);
    this.handletoExport = this.handletoExport.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.popup_content .popup_content_item .text_area', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const {
      isOpenMPE, isLoading,
    } = this.props;
    if (prevProps.isOpenMPE !== isOpenMPE) {
      this.setState({
        isOpenMPE,
        exportType: 'report',
        exportFormat: 'excel',
        selectedVersion: 'all',
        datesRange: '',
        versionList: [],
        radioValue: 'udtime_any',
        startId: 0,
        endId: 0,
        reportAfterExport: {},
        precisionLevel: '',
        toExport: 'local',
      });
    }

    if (prevProps.isLoading !== isLoading && isLoading) {
      this.setState({
        isLoading,
      }, () => {
        this.getProjectExportList();
      });
    }
  }

  handletoExport(e, { value }) {
    this.setState({
      toExport: value,
    });
  }

  handleVersionChange(e, { value }) {
    const { selectedVersion } = this.state;

    if (value === selectedVersion) {
      return;
    }
    this.setState({
      selectedVersion: value,
    });
  }

  handleDateRange = (event, { name, value }) => {
    this.setState({ [name]: value });
  };

  handleIntervalStartChange(e, { value }) {
    if (value < 0) {
      return;
    }
    this.setState({
      startId: value,
    });
  }

  handleIntervalEndChange(e, { value }) {
    if (value < 0) {
      return;
    }
    this.setState({
      endId: value,
    });
  }

  handleRadioChange(e, { value }) {
    this.setState({
      radioValue: value,
    });
  }

  onCloseHandler(e) {
    const { onClose } = this.props;
    if (e.target.classList[0] === 'right_button') {
      return null;
    }
    onClose();
  }

  onExport() {
    const {
      exportFormat,
      exportType,
      selectedVersion,
      datesRange,
      radioValue,
      startId,
      endId,
      reportAfterExport,
      toExport,
      precisionLevel
    } = this.state;
    const { handleModal } = this.props;
    const data = {};
    data.file_format = exportFormat;
    data.precision_level = precisionLevel;

    if (selectedVersion !== 'all') {
      data.project_version_id = selectedVersion;
    }

    data.filter = radioValue;

    if (radioValue === 'udtime_cr') {
      const [startDate, endDate] = datesRange.split(' - ');
      data.uploaded_start = startDate;
      data.uploaded_end = endDate;
    }

    if (radioValue === 'udid_cr') {
      data.start_id = startId;
      data.end_id = endId;
    }

    if (radioValue === 'udid_last') {
      data.start_id = reportAfterExport.start_id;
    }

    data.export_to = toExport;

    handleModal(data, exportType);
  }

  getProjectExportList = () => {
    const { projectId, initLoading, translate } = this.props;
    api
      .getProjectExportList(projectId)
      .then((res) => {
        const data = res.response;
        const versions = [{ key: 'all', text: translate('settings.list.all_versions'), value: 'all' }];

        if (data.version_list.length !== 0) {
          data.version_list.map((item) => {
            return versions.push(
              {
                key: item.id,
                text: item.name,
                value: item.id
              }
            );
          });
        }

        this.setState({
          isLoading: false,
          versionList: versions,
          reportAfterExport: data.report_after_export,
          precisionLevel: data.precision_level,
        });
        initLoading();
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  };

  setPrecisionLevel(precision) {
    let data;
    if (precision && precision !== '') {
      data = precision.replace(/^[a-z]/, (char) => { return char.toUpperCase(); });
    } else {
      data = '';
    }

    if (typeof data !== 'undefined') {
      return data || 'N/A';
    }
    return data.isShowPrecisionLevelMenu ? data.currentPrecisionLevel : 'N/A';
  }

  render() {
    const {
      isDownloading,
      translate,
      projectName,
    } = this.props;
    const {
      isOpenMPE,
      selectedVersion,
      radioValue,
      datesRange,
      isLoading,
      versionList,
      startId,
      endId,
      reportAfterExport,
      precisionLevel,
      toExport
    } = this.state;

    const currentLocale = localStorage.getItem('i18nextLng');

    const options = [
      { key: 'local', text: 'Local File System', value: 'local' },
      { key: 's3', text: 'S3', value: 's3' },
      { key: 'email', text: 'Email', value: 'email' },
    ];

    const getModalContent = () => {
      if (isDownloading) {
        return (
          <div className="modal_popup_wrap export_data_wrap">
            <div className="modal_popup_box export_data_box">
              <div className="modal_popup export_data">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader
                    style={{
                      position: 'relative',
                      width: '80%',
                      height: '80%',
                      marginBottom: '15%',
                    }}
                  />
                  <span
                    style={{
                      fontWeight: '500',
                      fontSize: '16px',
                      marginTop: '35%',
                      display: 'inline-block',
                    }}
                  >
                    {translate('modal.message.prepare_report_download')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      }

      if (isLoading) {
        return (
          <div className="modal_popup_wrap export_data_wrap">
            <div className="modal_popup_box export_data_box">
              <div className="modal_popup export_data">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader
                    style={{
                      position: 'relative',
                      width: '80%',
                      height: '80%',
                      marginBottom: '15%',
                    }}
                  />
                  <span
                    style={{
                      fontWeight: '500',
                      fontSize: '16px',
                      marginTop: '35%',
                      display: 'inline-block',
                    }}
                  >
                    {translate('modal.message.prepare_report_data')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className="modal_popup_wrap export_data_wrap">
          <div className="modal_popup_box export_data_box">
            <div className="modal_popup project_export">
              <h2 className="title">
                {translate('modal.title.export_data')}
                <a
                  className="close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.onCloseHandler}
                  onKeyUp={this.onCloseHandler}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </h2>
              <div className="popup_content">
                <Form>
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label={translate('modal.title.selected_project')}
                      value={projectName}
                      readOnly
                    />
                    <Form.Field>
                      <label>{translate('project.menu.project_version')}</label>
                      <Form.Dropdown
                        options={versionList}
                        selection
                        defaultValue={selectedVersion}
                        onChange={this.handleVersionChange}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label>{translate('contents_header.menu.last_uploaded_date')}</label>
                      <List>
                        <List.Item>
                          <Radio
                            label={translate('contents_header.menu.any_time')}
                            value="udtime_any"
                            checked={radioValue === 'udtime_any'}
                            onChange={this.handleRadioChange}
                          />
                        </List.Item>
                        <List.Item>
                          <Radio
                            label={translate('contents_header.menu.past_24_hours')}
                            value="udtime_p24"
                            checked={radioValue === 'udtime_p24'}
                            onChange={this.handleRadioChange}
                          />
                        </List.Item>
                        <List.Item>
                          <Radio
                            label={translate('contents_header.menu.past_week')}
                            value="udtime_pw"
                            checked={radioValue === 'udtime_pw'}
                            onChange={this.handleRadioChange}
                          />
                        </List.Item>
                        {
                          reportAfterExport && reportAfterExport.start_id
                          && (
                            <List.Item>
                              <Radio
                                label={reportAfterExport.display}
                                value="udid_last"
                                checked={radioValue === 'udid_last'}
                                onChange={this.handleRadioChange}
                              />
                            </List.Item>
                          )
                        }
                        <List.Item>
                          <Radio
                            label={translate('modal.title.custom_range_date')}
                            value="udtime_cr"
                            checked={radioValue === 'udtime_cr'}
                            onChange={this.handleRadioChange}
                          />
                          <div className="date_range_picker_wrap">
                            {radioValue === 'udtime_cr' ? (
                              <DatesRangeInput
                                className="date_range"
                                name="datesRange"
                                placeholder={translate('contents_header.place_holder.from_to')}
                                value={datesRange}
                                iconPosition="left"
                                onChange={this.handleDateRange}
                                closable
                                dateFormat={currentLocale === 'kr' || currentLocale === 'ja' ? 'YYYY-MM-DD' : 'DD-MM-YYYY'}
                                closeOnMouseLeave={false}
                              />
                            ) : null}
                          </div>
                        </List.Item>
                        <List.Item>
                          <Radio
                            label={translate('modal.title.custom_range_id')}
                            value="udid_cr"
                            checked={radioValue === 'udid_cr'}
                            onChange={this.handleRadioChange}
                          />
                          <div className="date_range_picker_wrap">
                            {radioValue === 'udid_cr' ? (
                              <div className="interval">
                                <Input
                                  type="number"
                                  placeholder={translate('project.menu.from')}
                                  value={startId}
                                  onChange={this.handleIntervalStartChange}
                                />
                                <label>-</label>
                                <Input
                                  type="number"
                                  placeholder={translate('project.menu.to')}
                                  value={endId}
                                  onChange={this.handleIntervalEndChange}
                                />
                              </div>
                            ) : null}
                          </div>
                        </List.Item>
                      </List>
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.title.file_export_to')}</label>
                      <Form.Dropdown
                        options={options}
                        selection
                        defaultValue={toExport}
                        onChange={this.handletoExport}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label={translate('modal.title.file_format')}
                      value={translate('modal.title.excel')}
                      readOnly
                    />
                    <Form.Input
                      fluid
                      label={translate('modal.title.precision_level')}
                      value={this.setPrecisionLevel(precisionLevel)}
                      readOnly
                    />
                  </Form.Group>
                </Form>
              </div>
              <div className="button_wrap">
                <a
                  className="left_button"
                  onClick={this.onCloseHandler}
                  onKeyUp={this.onCloseHandler}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="right_button"
                  onClick={this.onExport}
                  onKeyUp={this.onExport}
                >
                  {translate('modal.button.export')}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <Modal open={isOpenMPE} onClose={this.onCloseHandler}>
        {getModalContent()}
      </Modal>
    );
  }
}

export default ProjectExportModal;
